import React, { forwardRef, memo } from 'react'

import * as Styled from './styled'

interface IProps {
  src?: string
  onClick?: () => void
}
const RecentlyUsedImage = forwardRef<
  HTMLDivElement,
  IProps & React.HTMLAttributes<HTMLDivElement>
>(({ src, onClick, ...rest }, ref) => {
  return (
    <Styled.RecentlyUsedImageWrapper ref={ref} onClick={onClick} {...rest}>
      <Styled.RecentlyUsedImage src={src} />
    </Styled.RecentlyUsedImageWrapper>
  )
})
RecentlyUsedImage.displayName = 'RecentlyUsedImage'

export default memo(RecentlyUsedImage)
